// extracted by mini-css-extract-plugin
module.exports = {"count":"Footer_count__2A6bB"};